import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { APP_ROUTES } from '../constants/app-routes';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/', APP_ROUTES.employer.base, APP_ROUTES.employer.list]);
      return false; 
    }
    return true; 
  }
}
